<template>
  <v-container class="px-0" fluid>
    <v-checkbox
      v-model="inputVal"
      label="Reset veryfied"
    ></v-checkbox>
  </v-container>
</template>

<script>
export default {
  components: {
    //
  },
  props: ["value"],
  data: () => ({
  }),
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    //
  },
  mounted() {
  
  },
  methods: {
    //
  },
};
</script>